import { createFileRoute } from "@tanstack/react-router";
import {
  MediaPerformancePage,
  MediaPerformancePending,
  mediaPerformanceLoader,
} from "./$orgSlug.index";

export const Route = createFileRoute("/_authenticated/$orgSlug/media-performance/")({
  loaderDeps: ({ search }) => search,
  loader: ({ params, deps, context }) =>
    context.reportingView.unavailable.length
      ? undefined
      : mediaPerformanceLoader(params.orgSlug, deps, context.queryClient),
  pendingMs: 200,
  pendingMinMs: 300,
  pendingComponent: MediaPerformancePending,
  component: () => <MediaPerformancePage viewOverride="overview" />,
});
